// extracted by mini-css-extract-plugin
export default {"root":"Kt5mH"};